<template>
  <div>
    <el-card>
      <el-button @click="getBank">重新选择金融机构</el-button>
    </el-card>
    <el-card>
      <el-button @click="setDialogVisible = true">修改密码</el-button>
    </el-card>
    <!-- 密码修改框 -->
    <el-dialog title="密码修改对话框" :visible.sync="setDialogVisible" width="30%" :before-close="sethandleClose">

      <el-form :model="userFormData" :rules="rules" ref="userFormDataRef" label-width="0px" class="login_form">
        <el-form-item prop="oldPassword">
          <el-input placeholder="请输入原密码" prefix-icon="el-icon-search" show-password v-model="userFormData.oldPassword">
          </el-input>
        </el-form-item>
        <el-form-item prop="newPassword">
          <el-input placeholder="请输入新密码" prefix-icon="el-icon-search" show-password v-model="userFormData.newPassword">
          </el-input>
        </el-form-item>
        <el-form-item prop="passwordX">
          <el-input placeholder="请确认新密码" prefix-icon="el-icon-search" show-password v-model="userFormData.passwordX">
          </el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button type="primary" @click="editUserPasswordBtn()">确定</el-button>
          <el-button type="info" @click="resetLoginForm()">重置</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
    <!-- 金融机构选择框 -->
    <el-dialog title="请选择要进入的金融机构" :visible.sync="getDialogVisible" width="30%" :before-close="handleClose">
      <!-- 银行列表选择 -->
      <el-card class="box-card">
        <div index="item.id" v-for="item in bankData" :key="item.id">
          <el-tag class="bank-name" type="success" @click="getOrg(item.id, item.name)">{{item.name }}</el-tag>
        </div>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserManageFIs,
  getSubORGListByFI,
  editUserPassword
} from '@/api/user'
export default {
  data() {
    // 自定义一个函数，用于判断密码是否输入和密码长度是否达标
    const validatePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (value.length < 6 || value.length > 18) {
        callback(new Error('新密码6-18位长度'))
      } else {
        callback()
      }
    }
    // 设置一个判断函数,用判断新旧密码是否一致和是否有值
    const validatePwd1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认密码'))
      } else if (value !== this.userFormData.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isCollapse: false,
      formData: {
        count: 10,
        offset: 0
      },
      bankData: [],
      orgFromData: {
        FIId: '',
        count: 10,
        offset: 0
      },
      orgData: [],
      indexFrom: '', // 被激活的地址
      getDialogVisible: false,
      setDialogVisible: false,
      bankName: '',
      userFormData: {
        userId: '',
        oldPassword: '',
        newPassword: '',
        passwordX: ''
      },

      // 表单验证规则
      rules: {
        oldPassword: [
          { required: true, message: '请输入密码1', trigger: 'blur' },
          { min: 6, message: '长度不小于6个字符', trigger: 'blur' }
        ],
        newPassword: [
          {
            validator: validatePwd,
            trigger: 'blur'
          }
        ],
        passwordX: [
          {
            validator: validatePwd1,
            trigger: 'blur'
          }
        ]

      }

    }
  },
  methods: {

    // 修改密码
    editUserPasswordBtn() {
      debugger
      this.$refs.userFormDataRef.validate(valid => {
        debugger
        console.log(valid)
        if (!valid) return
        this.tableLoading = true
        editUserPassword(this.userFormData).then(res => {
          debugger
          this.tableLoading = false
          if (res.data.c === 1) {
            this.setDialogVisible = false // 关闭修改密码对话框
            return this.$message.success('修改成功！！')
          }
          this.$message.error('旧密码错误！！')
        })
      })
    },
    // 修改密码对话框中的关闭按钮
    /* sethandleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    }, */
    // 重置密码提交表单
    resetLoginForm() {
      // 调用表单上的ref="formDataRef"属性调用resetFields()方法重置表单数据
      this.$refs.userFormDataRef.resetFields()
    },
    // 查询用户绑定的金融机构
    getBank() {
      debugger
      const bankDatax = JSON.parse(localStorage.getItem('bankData'))
      if (bankDatax === null) {
        this.tableLoading = true
        getUserManageFIs(this.formData).then(res => {
          debugger
          this.tableLoading = false
          if (res.status !== 200) return this.$message.error('远程服务器没有响应')
          console.log(res.data.c)
          if (res.data.c === 'invalid token') {
            this.$router.push('/login')
            this.$message.error('登录已失效，请重新登录')
            return
          }
          this.bankData = res.data.c
          // 写本地存入token的方法
          localStorage.setItem('bankData', JSON.stringify(this.bankData))
          this.$store.commit('bankOrg', this.bankData[0].id)
          this.getDialogVisible = true //
        })
      } else {
        this.bankData = bankDatax
        this.getDialogVisible = true
      }
    },
    getOrg(key, name) {
      debugger
      // console.log(key)
      this.indexFrom = '/orgList'
      this.orgFromData.FIId = key // 存入选择的银行Id
      this.bankName = name // 存入选择的银行名称
      this.getDialogVisible = false // 关闭银行选择弹框
      localStorage.setItem('indexFrom', JSON.stringify(this.indexFrom))
      localStorage.setItem('orgFromData', JSON.stringify(this.orgFromData))
      this.tableLoading = true
      getSubORGListByFI(this.orgFromData).then(res => {
        if (res.data.c === 'invalid token') {
          this.$router.push('/login')
          this.$message.error('登录已失效，请重新登录')
          return
        }
        this.tableLoading = false
        debugger
        console.log(res.data.c.data)
        this.orgData = res.data.c.data
        localStorage.setItem('orgData', JSON.stringify(this.orgData))
        this.$router.push('/orgList')
      })
    }
  },
  created() {
    const setUserInfo = JSON.parse(localStorage.getItem('setUserInfo'))
    this.userFormData.userId = setUserInfo.id
  }
}
</script>

<style lang="less" scoped>
  .bank-name {
    width: 100%;
    background-color: #4A5064; // 背景色
    font-size: 1.0rem; // 字体大小
    line-height: 2.5rem; // 行高
    color: #fff; // 字体颜色
    text-align: center; // 居中
    letter-spacing: 0.7em; // 字体间距
    cursor: pointer; // 鼠标变手指
  }
</style>
